import { FormGroupState, unbox } from 'ngrx-forms';

/* eslint-disable @angular-eslint/component-class-suffix */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal';

import { AuthFacade } from '../../+state/auth.facade';
import { ChangePasswordFormValue } from '../../+state/auth.reducer';

@Component({
  standalone: false,
  templateUrl: './change-password-modal.container.html',
  styleUrls: ['./change-password-modal.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordModalContainer {
  form$ = this.authFacade.changePasswordForm$;

  constructor(
    private authFacade: AuthFacade,
    public activeModal: NgbActiveModal
  ) {}

  onSubmit(form: FormGroupState<ChangePasswordFormValue>) {
    if (form.isValid) {
      this.activeModal.close({
        password: unbox(form.value.password),
        newPassword: form.value.newPassword,
      });
    }
  }

  cancel() {
    this.activeModal.close();
  }
}
